import { convertPeriodToISO, validateDateRange } from '@skbkontur/staff-common';
export const arrayToRecord = (items) => {
    const reducer = (acc, cur) => {
        acc[cur.id] = cur;
        return acc;
    };
    return items.reduce(reducer, {});
};
export const getInitialPeriod = (initial) => {
    if (!initial || !validateDateRange(initial.employmentPeriodBegin, initial.employmentPeriodEnd)) {
        return {};
    }
    return convertPeriodToISO(initial.employmentPeriodBegin, initial.employmentPeriodEnd);
};
